import {
  IconBed,
  IconCar,
  IconCompass,
  IconConfetti,
  IconRoute,
  IconStar,
  IconToolsKitchen2,
} from "@tabler/icons-react";

export const TOUR_SECTION_ICON_OPTIONS = [
  { value: "star", label: "Star", Icon: IconStar },
  { value: "route", label: "Route", Icon: IconRoute },
  { value: "compass", label: "Compass", Icon: IconCompass },
  { value: "car", label: "Car", Icon: IconCar },
  { value: "bed", label: "Bed", Icon: IconBed },
  { value: "restaurant", label: "Restaurant", Icon: IconToolsKitchen2 },
  {
    value: "festival_activities",
    label: "Festival & Activities",
    Icon: IconConfetti,
  },
];

export const DEFAULT_SECTION_ICON = IconStar;
